import axios from 'axios';

import { EntityId, EntityKind, UserPreference } from 'types/models/user-preference';
import { APIResponseParsed } from 'types/response';
import { getRequest, putRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

// ================================================
// TYPES
// ================================================
export type FetchUserPreferencesParams = {
  entityKind?: EntityKind;
  /** If specified, must specify an entityKind too */
  entityId?: EntityId;
};

export interface UpdateUserPreferenceDTO extends Omit<UserPreference, 'id' | 'userId'> { }

// ================================================
// REQUESTS
// ================================================
export async function fetchPreferences(
  { entityKind, entityId }: FetchUserPreferencesParams
): Promise<APIResponseParsed<UserPreference[]>> {
  try {
    const response = await getRequest<UserPreference[]>('user-preferences', {
      params: { entityKind, entityId }
    });
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export async function editPreference(
  updatedPreference: UpdateUserPreferenceDTO
): Promise<APIResponseParsed<UserPreference>> {
  try {
    const response = await putRequest<UserPreference, UpdateUserPreferenceDTO>(
      'user-preferences',
      updatedPreference
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}
